export const GUEST_CHOSEN_LOCALE_STORAGE_KEY = 'chosenLocale'
export const GUEST_THEME_STORAGE_KEY = 'theme'
